module.exports = __webpack_public_path__ + "media/torsten6.c2cf378b.mp3";